import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { closeAuthBrowser, isNativeAuthCallbackUrl, isNativePlatform } from '../utils/native';

// Routes URLs that open the native app (Suunto OAuth redirect) into the router.
const NativeUrlHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) return;

    const listener = CapacitorApp.addListener('appUrlOpen', ({ url }) => {
      if (!isNativeAuthCallbackUrl(url)) return;
      const query = url.includes('?') ? url.slice(url.indexOf('?')) : '';
      void closeAuthBrowser();
      navigate(`/auth/callback${query}`);
    });

    return () => {
      void listener.then(l => l.remove());
    };
  }, [navigate]);

  return null;
};

export default NativeUrlHandler;
